import DesktopSearch from './DesktopSearch';

export { default as CloseBtn } from './CloseBtn';
export { default as SearchAutocompletesList } from './SearchAutocompletesList';
export { default as SearchHeader } from './SearchHeader';
export { default as SwitchButtonsList } from './SwitchButtonsList';
export { default as TitlesWritersList } from './TitlesWritersList';

export default DesktopSearch;
